export const getNorthCanterburyData = () => ({
  name: "North Canterbury",
  region: "Canterbury",
  country: "Nouvelle-Zélande",
  description: "North Canterbury est une sous-région viticole dynamique, réputée pour ses vins rouges et blancs équilibrés. Les sols argileux et le climat tempéré favorisent la production de vins de qualité.",
  type: "subregion",
  area: "400 ha",
  production: "0.03 million hectolitres",
  climate: "Climat tempéré avec influences maritimes et alpines, étés frais et hivers froids",
  soil: "Sols argileux, bonne rétention d'eau, diversité géologique",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes et alpines, étés frais et hivers froids",
    soil: "Sols argileux, bonne rétention d'eau, diversité géologique",
    viticulture: "Viticulture durable, rendements contrôlés, diversité de cépages"
  },
  wineStyles: {
    white: "Chardonnay équilibré, Sauvignon Blanc frais, Pinot Gris aromatique",
    red: "Pinot Noir élégant, tanins fins",
    rosé: "Rosés fruités et délicats"
  },
  history: "North Canterbury s'est imposée dans les années 2000 comme une zone viticole innovante, avec une attention particulière à la durabilité et à la qualité.",
  foodPairing: "Viandes blanches, poissons, fromages affinés, plats locaux",
  grapeVarieties: [
    { name: "Pinot Noir", percentage: "35%", description: "Vins rouges élégants, tanins fins" },
    { name: "Chardonnay", percentage: "30%", description: "Vins blancs équilibrés, notes de fruits blancs" },
    { name: "Sauvignon Blanc", percentage: "20%", description: "Vins frais, aromatiques, acidité vive" },
    { name: "Pinot Gris", percentage: "10%", description: "Vins blancs aromatiques, texturés" },
    { name: "Autres", percentage: "5%", description: "Riesling, Gewürztraminer, expérimentaux" }
  ],
  statistics: {
    totalArea: "400 ha",
    production: "0.03 million hectolitres",
    wineries: "8+ domaines",
    exportPercentage: "30%"
  },
  viticulture: "La viticulture à North Canterbury privilégie la diversité des cépages et la durabilité. Les rendements sont limités pour préserver la fraîcheur et la complexité.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "North Canterbury est caractérisée par ses sols argileux et son climat tempéré, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "North Canterbury", x: 172.7, y: -43.3, color: "#6d2c7a", size: 3 }
  ]
}); 